export function initFloorplan() {
    var blocks = document.querySelectorAll('.floorplan-block');
    var mq = window.matchMedia('(min-width: 768px)');

    blocks.forEach(function (block) {
        var buttons = block.querySelectorAll('.floorplan-block__floor-btn');
        var media = block.querySelector('.floorplan-block__media');
        var image = media ? media.querySelector('.floorplan-block__image') : null;

        if (!buttons.length) return;

        buttons.forEach(function (btn) {
            btn.addEventListener('click', function () {
                var floor = btn.closest('.floorplan-block__floor');
                var isAlreadyActive = floor.classList.contains('floorplan-block__floor--active');

                buttons.forEach(function (b) {
                    b.closest('.floorplan-block__floor').classList.remove('floorplan-block__floor--active');
                    b.setAttribute('aria-pressed', 'false');
                });

                // Desktop: always activate. Mobile: toggle (tap active floor to close).
                if (mq.matches || !isAlreadyActive) {
                    floor.classList.add('floorplan-block__floor--active');
                    btn.setAttribute('aria-pressed', 'true');
                }

                // Desktop only: swap shared media panel image.
                if (mq.matches && image) {
                    var src = btn.getAttribute('data-image-src');
                    var alt = btn.getAttribute('data-image-alt') || '';
                    if (!src) return;

                    image.style.opacity = '0';
                    if (media) media.classList.add('floorplan-block__media--loading');

                    image.onload = function () {
                        if (media) media.classList.remove('floorplan-block__media--loading');
                        image.style.opacity = '1';
                    };
                    image.onerror = function () {
                        if (media) media.classList.remove('floorplan-block__media--loading');
                        image.style.opacity = '1';
                    };

                    image.src = src;
                    image.alt = alt;
                }
            });
        });
    });
}
